































import Vue from "vue";
import AdvertisementForm from "@/components/Form/AdvertisementForm.vue";
import { Advertisement } from "@/interfaces/advertisement";
import _ from "lodash";
import { HeaderProcess } from "@/plugins/HeaderProcess";
import { MediaObject } from "@/interfaces/mediaobject";
export default Vue.extend({
  components: { AdvertisementForm },
  computed: {
    _() {
      return _;
    },
    headerProcess() {
      const hp = new HeaderProcess();
      hp.processes.push({ idx: 1, title: "広告修正" });
      hp.processes.push({ idx: 2, title: "広告修正確認画面" });
      hp.processes.push({ idx: 3, title: "広告修正完了" });

      hp.activeIdx = this.phase == "input" ? 1 : 2;

      return hp;
    },
    isPage() {
      return true;
    },
  },
  data() {
    return {
      advertisement: {
        mapParameters: "",
      } as Partial<Advertisement>,
      errors: {},
      isLoading: true,
      phase: "input",
    };
  },
  mounted() {
    (async () => {
      this.advertisement = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.params.id,
      ]);
      for (const i of [1, 2, 3, 4, 5]) {
        const k = ("image" + i) as
          | "image1"
          | "image2"
          | "image3"
          | "image4"
          | "image5";
        if (!this.advertisement.eyeCatch) {
          continue;
        }
        if (!this.advertisement[k]) {
          continue;
        }
        const eyeCatchId = this.advertisement.eyeCatch["@id"];
        const imageId = (this.advertisement[k] as MediaObject)["@id"];
        if (eyeCatchId == imageId) {
          this.$set(this.advertisement, "eyecatchIndex", i);
        }
      }
      this.$forceUpdate();
      this.isLoading = false;
    })();
  },
  methods: {
    async confirm() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, unknown> = {};
      for (const [k, v] of Object.entries(this.advertisement)) {
        if (_.isPlainObject(v) && (v as { "@id"?: string })["@id"]) {
          postData[k] = (v as { "@id"?: string })["@id"];
        } else {
          postData[k] = v;
        }
      }

      try {
        const decorated = await this.decoratePostData(postData);
        await this.$store.dispatch("post", [
          "/api/adv/posts/validate",
          decorated,
        ]);
        this.phase = "confirm";
      } catch (violations) {
        for (const v of violations as {
          propertyPath: string;
          message: string;
        }[]) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
        (
          document.getElementsByClassName("main")[0] || document.body
        ).scrollIntoView({
          behavior: "auto",
          block: "start",
        });
      }
      this.isLoading = false;
    },
    async exec() {
      this.errors = {};
      this.isLoading = true;
      const postData: { [key: string]: unknown } = {};
      for (const [k, v] of Object.entries(this.advertisement)) {
        if (_.isPlainObject(v) && (v as { "@id"?: string })["@id"]) {
          postData[k] = (v as { "@id"?: string })["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        const ret = await this.$store.dispatch("put", [
          "/api/adv/posts/" + this.$route.params.id,
          decorated,
        ]);

        if (this.advertisement.publishmentOrder) {
          await this.$store.dispatch("patch", [
            "/api/adv/publishment_orders/" +
              this.advertisement.publishmentOrder.id +
              "/reapply",
            decorated,
          ]);
        }

        this.phase = "confirm";
        this.$router.push({
          name: "AdvertiserAdvertisementsComplete",
          params: { id: ret.id },
        });
      } catch (ex) {
        alert("登録時にエラーが発生しました");
      }
      this.isLoading = false;
    },
    async decoratePostData(postData: Record<string, unknown>) {
      const form = this.$refs.form as Vue & {
        files: Record<string, HTMLInputElement | undefined>;
      };
      const fileViolations = [];
      for (const [key, file] of Object.entries(form.files)) {
        if (file) {
          try {
            const ret = await this.$store.dispatch("uploadFile", file);
            postData[key] = ret["@id"];
            this.$set(this.advertisement, key, ret);
          } catch (violations) {
            console.error(violations);
            // this.$delete(this.advertisement, key);
            for (const v of violations as {
              propertyPath: string;
              message: string;
            }[]) {
              fileViolations.push({ propertyPath: key, message: v.message });
            }
          }
          form.files[key] = undefined;
        }
      }
      if (fileViolations.length) {
        throw fileViolations;
      }
      postData["eyeCatch"] = postData["image" + postData["eyecatchIndex"]];
      postData["owner"] = this.$store.getters.my().advertiser;

      delete postData.publicAdvertisement;
      delete postData.publishmentOrder;

      return postData;
    },
  },
});
